import type { ReactNode } from 'react';
import './insights.css';

export interface RangeSwitchProps<T extends string | number> {
  options: readonly { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
  /** Spoken name of the group: "Range". */
  label: string;
}

/** A row of pressed-or-not buttons for a chart's range: one press, no menu. */
export function RangeSwitch<T extends string | number>(props: RangeSwitchProps<T>): ReactNode {
  const { options, value, onChange, label } = props;
  return (
    <div className="ad-switch" role="group" aria-label={label}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          aria-pressed={value === o.value}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
